import { LocalstorageProvider } from "./../localstorage/localstorage";
import { Injectable } from "@angular/core";
import configApp from "../../psapp-config";

/*
  Generated class for the AppcacheManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AppcacheManagerProvider {
  constructor(private localstorageProvider: LocalstorageProvider) {}

  isAppCache() {
    //return true;
    return !("serviceWorker" in navigator);
  }

  isAppCacheValid(key) {
    return this.isAppCache() && this.checkBlackList(key);
  }

  checkBlackList(key) {
    if (configApp.endPoints.Login.indexOf(key) !== -1) {
      return false;
    }

    if (configApp.endPoints.PostPOS.indexOf(key) !== -1) {
      return false;
    }

    if (configApp.endPoints.PostSpot.indexOf(key) !== -1) {
      return false;
    }

    return true;
  }

  saveCache(key, data) {
    this.localstorageProvider.write(key, data);
  }

  restoreCache(key) {
    return this.localstorageProvider.read(key);
  }
}
